export default function comments({ context }) {

  const devUrl = 'https://staging18.staging.gb.ru/api/v2/comments'
  const prodUrl = 'https://gb.ru/api/v2/comments'

  const baseUrl = context.$config.isProd ? prodUrl : devUrl

  return {
    async createComment(formData) {
      try {
        const { data } = await context.$axios.post(`${baseUrl}`, formData)

        return data
      } catch (e) {
        console.error(e)
      }
    },

    async updateComment(id, body) {
      try {
        const { data } = await context.$axios.put(`${baseUrl}/${id}`, { comment: { body } })

        return data
      } catch (e) {
        console.error(e)
      }
    }

  }
}
